import { FC } from 'react';

import { useSelector } from '@hh.ru/front-static-app';

import ProxyComponentName from 'src/constants/proxyComponentName';

import SalaryMarketRangeCard from 'src/proxyComponents/SalaryMarketRangeCard';
import VacancyAdvicesModal from 'src/proxyComponents/VacancyAdvicesModal';
import VacancyConversionChartSmall from 'src/proxyComponents/VacancyConversionChartSmall';

const ProxyComponentMap = {
    [ProxyComponentName.SalaryMarketRangeCard]: SalaryMarketRangeCard,
    [ProxyComponentName.VacancyAdvicesModal]: VacancyAdvicesModal,
    [ProxyComponentName.VacancyConversionChartSmall]: VacancyConversionChartSmall,
};

const isValidComponent = (pageName: string): pageName is keyof typeof ProxyComponentName =>
    pageName in ProxyComponentMap;

const ProxyComponents: FC = () => {
    const pageName = useSelector(({ request }) => request.pageName);

    if (isValidComponent(pageName)) {
        const Component = ProxyComponentMap[pageName];
        return <Component />;
    }

    return null;
};

export default ProxyComponents;
